<template>
  <div class="emp-cert">
    <div class="search-bar">
      <span class="label">员工姓名：</span>
      <el-select
        v-model="selectedName"
        filterable
        clearable
        placeholder="请选择或搜索员工"
        style="width: 200px;"
        @change="onEmployeeChange"
      >
        <el-option
          v-for="item in employeeOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
      <span class="label" style="margin-left:16px;">证书类别：</span>
      <el-input
        v-model="queryForm.certificateType"
        placeholder="请输入证书类别"
        clearable
        style="width: 160px;"
      />
      <el-button type="primary" icon="el-icon-search" style="margin-left:8px;" @click="fetchData">查询</el-button>
      <el-button type="success" icon="el-icon-plus" style="margin-left:8px;" @click="openAdd">新增</el-button>
    </div>

    <el-table :data="tableData" border v-loading="loading" style="margin-top:12px;">
      <el-table-column prop="personnelName" label="员工姓名" align="center" width="100" />
      <el-table-column prop="certificateType" label="证书类别" align="center" min-width="120" />
      <el-table-column prop="certificateNo" label="证书编号" align="center" min-width="130" />
      <el-table-column label="有效期" align="center" width="210">
        <template slot-scope="{ row }">
          <span v-if="row.certificateDateStart && row.certificateDateEnd">
            {{ row.certificateDateStart.substring(0, 10) }} ~ {{ row.certificateDateEnd.substring(0, 10) }}
          </span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="获证日期" align="center" width="110">
        <template slot-scope="{ row }">
          {{ row.certificateDate ? row.certificateDate.substring(0, 10) : '-' }}
        </template>
      </el-table-column>
      <el-table-column prop="content" label="备注" align="center" min-width="100" show-overflow-tooltip />
      <el-table-column label="操作" align="center" width="100">
        <template slot-scope="{ row }">
          <el-button size="mini" type="primary" plain @click="openEdit(row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      style="margin-top:12px; text-align:right;"
      :current-page="queryForm.pageNum"
      :page-size="queryForm.pageSize"
      :total="total"
      layout="total, prev, pager, next"
      @current-change="onPageChange"
    />

    <!-- 新增/编辑弹窗 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="700px" :close-on-click-modal="false">
      <el-form :model="form" label-width="110px" size="small">
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="员工姓名" required>
              <el-select v-model="form.personnelName" filterable placeholder="请选择员工" style="width:100%">
                <el-option v-for="item in employeeOptions" :key="item.value" :label="item.label" :value="item.label" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="资格证书类型" required>
              <el-input v-model="form.certificateType" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="证书编号" required>
              <el-input v-model="form.certificateNo" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="获得证书日期">
              <el-date-picker
                v-model="form.certificateDate"
                type="datetime"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width:100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="证书有效期起">
              <el-date-picker
                v-model="form.certificateDateStart"
                type="datetime"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width:100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="证书有效期止">
              <el-date-picker
                v-model="form.certificateDateEnd"
                type="datetime"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width:100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注">
              <el-input v-model="form.content" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitForm">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'EmpCertification',
  data() {
    return {
      employeeOptions: [],
      selectedName: '',
      queryForm: { certificateType: '', pageNum: 1, pageSize: 10 },
      tableData: [],
      total: 0,
      loading: false,
      dialogVisible: false,
      dialogTitle: '新增证件信息',
      form: {
        id: '', personnelName: '', certificateType: '', certificateNo: '',
        certificateDateStart: '', certificateDateEnd: '', certificateDate: '', content: '',
      },
    };
  },
  created() {
    this.loadEmployees();
  },
  methods: {
    loadEmployees() {
      this.$postJson('uac/emp/queryUserListByEmpWithPage', {
        deptId: sessionStorage.getItem('groupId'),
        pageNum: 1,
        pageSize: 999,
      }).then((res) => {
        if (res && res.result && res.result.list) {
          this.employeeOptions = res.result.list.map((item) => ({
            label: item.userName,
            value: item.userName,
          }));
        }
      });
    },
    onEmployeeChange() {
      this.queryForm.pageNum = 1;
      this.fetchData();
    },
    fetchData() {
      this.loading = true;
      this.$postJson('omc/personnelCertificate/queryCertificateDataAll', {
        data: {
          personnelName: this.selectedName || undefined,
          certificateType: this.queryForm.certificateType || undefined,
        },
        pageNum: this.queryForm.pageNum,
        pageSize: this.queryForm.pageSize,
      }).then((res) => {
        this.loading = false;
        if (res && res.result) {
          this.tableData = res.result.list || [];
          this.total = Number(res.result.total || 0);
        }
      }).catch(() => { this.loading = false; });
    },
    onPageChange(page) {
      this.queryForm.pageNum = page;
      this.fetchData();
    },
    openAdd() {
      this.dialogTitle = '新增证件信息';
      this.form = {
        id: '', personnelName: this.selectedName || '',
        certificateType: '', certificateNo: '',
        certificateDateStart: '', certificateDateEnd: '', certificateDate: '', content: '',
      };
      this.dialogVisible = true;
    },
    openEdit(row) {
      this.dialogTitle = '编辑证件信息';
      this.form = { ...row };
      this.dialogVisible = true;
    },
    submitForm() {
      if (!this.form.personnelName) { this.$message.error('请选择员工'); return; }
      if (!this.form.certificateType) { this.$message.error('请输入证书类型'); return; }
      if (!this.form.certificateNo) { this.$message.error('请输入证书编号'); return; }
      const isEdit = !!this.form.id;
      const url = isEdit
        ? 'omc/personnelCertificate/updateCertificateData'
        : 'omc/personnelCertificate/addCertificateData';
      this.$postJson(url, this.form).then((res) => {
        if (res && res.code === 200) {
          this.$message.success(isEdit ? '修改成功' : '添加成功');
          this.dialogVisible = false;
          this.fetchData();
        }
      });
    },
  },
};
</script>

<style scoped>
.emp-cert { padding: 16px; }
.search-bar { display: flex; align-items: center; flex-wrap: wrap; gap: 4px; }
.label { font-size: 14px; color: #606266; }
</style>
